import {createSlice} from "@reduxjs/toolkit";

const initialCompanyApiKeysState = {
  listLoading: false,
  totalCount: 0,
  companyApiKeyItems: [],
  filterOptions: {companies: [], resellers: []},
  error: null,
};

export const callTypes = {
  list: "list"
};

export const companyApiKeysSlice = createSlice({
  name: "companyApiKeys",
  initialState: initialCompanyApiKeysState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      state.listLoading = false;
    },
    startCall: (state) => {
      state.error = null;
      state.listLoading = true;
      state.companyApiKeyItems = [];
      state.totalCount = 0;
    },
    companyApiKeysFetched: (state, action) => {
      const {totalCount, companyApiKeyItems} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.companyApiKeyItems = companyApiKeyItems;
      state.totalCount = totalCount;
    },
    filterOptionsFetched: (state, action) => {
      state.filterOptions = action.payload;
    },
    resetState: (state) => {
      state.listLoading = initialCompanyApiKeysState.listLoading;
      state.totalCount = initialCompanyApiKeysState.totalCount;
      state.companyApiKeyItems = initialCompanyApiKeysState.companyApiKeyItems;
    },
  }
});
